import React, {Component} from 'react';
import {Link} from "react-router-dom";
import styled from 'styled-components';

const SiteMapRoot = styled.div`
  
  h1, p {
  text-align: center;
  }
  ul {
    width: 200px;
    margin: 0 auto;
  }
`;


/**
 * For debugging and demostrying
 */
class SiteMap extends Component {


  render() {
    let zones = ["AU-NSW", "AU-NT", "AU-QLD", "AU-SA", "AU-TAS", "AU-WA", "AU-VIC", "AU-ACT"];

    return <SiteMapRoot>
      <h1>AutoVantage Site Map</h1>

      <ul>
        <li><Link to={'/VW/SG/'}/></li>
        {
          zones.map(i => {
            return <li><Link to={`/VW/${i}/`}>{`/VW/${i}/`}</Link></li>
          })
        }
      </ul>

      <p>
        For demonstration purpose only, should never go to production.
      </p>
    </SiteMapRoot>;
  }
}

export default SiteMap;


// WEBPACK FOOTER //
// ./src/SiteMap.js